import App  from '@core/app/app';
import AppOptions from '@core/app/options';
import VerticalVideo from '@core/libs/vertical_videos';
import Stories from '@core/libs/stories';
import Toc from '../libs/toc';
import ProgressBar from '../libs/progress_bar';
import VerticalVideoPreview from '@core/libs/vertical_videos_preview';
import Elections from '../libs/elections';

class App24ur2025 extends App {
    public toc: Toc;
    public progressBar: ProgressBar;
    public verticalVideo: VerticalVideo;
    public stories: Stories;
    public verticalVideoPreview: VerticalVideoPreview;
    public elections: Elections;

    constructor(
        options: AppOptions
    ) {
        super(options);

        this.toc = new Toc(this.html, this.rateLimiter);
        this.progressBar = new ProgressBar(this.html, this.rateLimiter);
        this.verticalVideo = new VerticalVideo(this.html, this.video, options);
        this.stories = new Stories(this.html, this.video, options)
        this.verticalVideoPreview = new VerticalVideoPreview(this.html);
        this.elections = new Elections(this.html);
    }

    run() {
        super.run();

        this.weather.showCorrectWeather();
    }
}

export default App24ur2025;
